import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrainingVideoApi extends ApiCommon {

  recordClick(videoId: string, videoTitle?: string): Observable<object> {
    const body: { videoId: string; videoTitle?: string } = { videoId };
    if (videoTitle != null && videoTitle !== '') {
      body.videoTitle = videoTitle;
    }
    return this.apiServer.trainingVideo.postTrainingVideoClick(body);
  }

  getViewCounts(userId?: any, startDate?: string | Date, endDate?: string | Date, isDealer?: any): Observable<{ videoId: string; videoTitle?: string; count: number }[]> {
    return this.apiServer.trainingVideo.getViewCounts(userId, startDate, endDate, isDealer);
  }
}
